<!-- prettier-ignore -->
<template>
  <aw-dropdown class="dropdown" placement="bottom-start" @show="onDropdownShow" @hide="onDropdownHide" v-model="opened">
      <template v-slot:btn>
        <div @click="openSelect" class="bg-white relative w-full text-left cursor-default dropdown-button">
          <template v-if="!multiple">
            <input type="text" v-model="searchInput.value" :placeholder="searchInput.placeholder" class="p-0 border-none outline-none ring-0 block w-full text-sm placeholder-gray-700" ref="search" @focus="openSelect">
            <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <!-- Heroicon name: selector -->
              <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </span>
          </template>
          <template v-else>
            <template v-for="option in selectedOptions" :key="option.id">
              <slot name="items" v-bind="{ option, removeOption }" />
            </template>
            <input type="text" v-model="searchInput.value" :placeholder="searchInput.placeholder" class="p-0 border-none inline-flex outline-none ring-0 text-sm placeholder-gray-700" ref="search" @focus="openSelect">
          </template>
        </div>
      </template>
      
      <template v-slot:dropdown="{ opened, dropdown }">
        <ul tabindex="-1" role="listbox" class="dropdown-menu max-w-full" v-show="opened" :ref="dropdown">
          <slot
              name="noresults"
              v-bind="{ searchInput }"
              v-if="showNoResults"
          >
            <li class="dropdown-item">Žádný výsledek nenalezen, změnte hledaný výraz</li>
          </slot>
          <slot
              name="maxresults"
              v-bind="{ searchInput, maxOptions, filteredOptions }"
              v-if="showMaxResultsExceeded"
          >
            <li class="dropdown-item">Zobrazeno prvních {{ maxOptions }} záznamů z {{ filteredOptions.length }}. Upřesněte hledaný výraz</li>
          </slot>
          <template v-for="(option, optionIndex) in filteredAndLimitedOptions" :key="option.id">
            <slot
              name="option"
              v-bind="{ option, handleMouseEnter, selectOption, highlighted: optionIndex === selectedIndex, selected: value.indexOf(option.id) !== -1 }"
            />
          </template>
        </ul>
      </template>
  </aw-dropdown>
</template>

<!-- prettier-ignore -->
<script>
import { search } from 'ss-search'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
// import { toRaw } from 'vue'
import clone from 'lodash/clone'

export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    defaultPlaceholder: {
      type: String,
      default: 'Vyberte'
    },
    maxOptions: {
      type: Number,
      default: 50
    },
    propFilteredOptions: {
      type: Function,
      default: null
    }
  },
  data() {
    let placeholder = this.defaultPlaceholder
    let selectedOption = null
    if (
      this.multiple === false &&
      (selectedOption = find(this.options, ['id', this.modelValue]))
    ) {
      placeholder = selectedOption.label
    } else if (this.multiple && this.modelValue.length > 0) {
      placeholder = ''
    }
    return {
      selectedIndex: 0,
      searchInput: {
        placeholder,
        value: ''
      },
      opened: false,
      value:
        this.multiple === false
          ? [clone(this.modelValue)]
          : clone(this.modelValue)
    }
  },
  computed: {
    filteredOptions () {
      if (this.propFilteredOptions) {
        return this.propFilteredOptions(this)
      }
      const options = this.multiple === false
        ? this.options
        : this.options.filter((a) => this.value.indexOf(a.id) === -1)

      if (this.searchInput.value == '') {
        return options
      }
      return search(options, ['label'], this.searchInput.value)
    },
    selectedOptions() {
      return this.value.map(itemId => find(this.options, ['id', itemId]))
    },
    showNoResults() {
      return this.filteredOptions.length === 0
    },
    showMaxResultsExceeded() {
      return this.filteredOptions.length > this.maxOptions
    },
    filteredAndLimitedOptions() {
      return this.filteredOptions.slice(0, this.maxOptions)
    }
  },
  methods: {
    addKeyHandler() {
      window.addEventListener('keydown', this.keyHandler)
    },
    removeKeyHandler() {
      window.removeEventListener('keydown', this.keyHandler)
    },
    keyHandler(e) {
      /**
        38 — up
        40 — down
         9 — tab
        13 — enter
        27 — escape
         8 - backspace
      **/
      const key = e.which || e.keyCode
      if (key === 38 /*|| (e.shiftKey && key === 9)*/) {
        this.handleKeyUp(e)
      } else if (key === 40 /*|| key === 9*/) {
        this.handleKeyDown(e)
      } else if (key === 13) {
        this.handleEnter(e)
      } else if (key === 27) {
        //this.handleEnter(e);
        e.preventDefault()
        this.closeSelect()
      } else if (key === 8) {
        //this.handleEnter(e);
        if (this.value.length && this.searchInput.value.length === 0) {
          e.preventDefault()
          this.value.pop()
        }
      }
    },
    handleEnter(e) {
      e.preventDefault()
      this.selectOption(this.filteredOptions[this.selectedIndex])
    },
    handleKeyUp(e) {
      e.preventDefault()
      if (this.selectedIndex <= 0) {
        // If index is less than or equal to zero then set it to the last item index
        this.selectedIndex = this.filteredOptions.length - 1
      } else if (
        this.selectedIndex > 0 &&
        this.selectedIndex <= this.filteredOptions.length - 1
      ) {
        // If index is larger than zero and smaller or equal to last index then decrement
        this.selectedIndex--
      }
    },
    handleKeyDown(e) {
      e.preventDefault()
      // Check if index is below 0
      // This means that we did not start yet
      if (
        this.selectedIndex < 0 ||
        this.selectedIndex === this.filteredOptions.length - 1
      ) {
        // Set the index to the first item
        this.selectedIndex = 0
      } else if (
        this.selectedIndex >= 0 &&
        this.selectedIndex < this.filteredOptions.length - 1
      ) {
        this.selectedIndex++
      }
    },
    handleMouseEnter(option) {
      this.selectedIndex = findIndex(this.filteredOptions, ['id', option.id])
    },
    selectOption(option) {
      if (!this.multiple) {
        this.searchInput.placeholder = option.label
        this.searchInput.value = ''

        this.value = [option.id]
        this.$emit('update:modelValue', this.value[0])

        this.$refs.search.blur()
        this.opened = false
      } else if (this.value.indexOf(option.id) === -1) {
        this.searchInput.placeholder = ''
        this.value.push(option.id)
        this.$emit('update:modelValue', this.value)
      } else {
        this.removeOption(option)
        if (this.value.length === 0) {
          this.searchInput.placeholder = this.defaultPlaceholder
        }
      }
    },
    removeOption(option) {
      this.value.splice(this.value.indexOf(option.id), 1)
      this.$emit('update:modelValue', this.value)
    },
    closeSelect() {
      this.searchInput.value = ''
      this.$refs.search.blur()
      this.opened = false
    },
    openSelect() {
      this.$refs.search.focus()
      this.opened = true
    },
    onDropdownShow() {
      this.addKeyHandler()
      this.$refs.search.focus()
    },
    onDropdownHide() {
      this.removeKeyHandler()
      this.searchInput.value = ''
      this.$refs.search.blur()
    }
  },
  watch: {
    'searchInput.value'() {
      this.selectedIndex = 0
    },
    modelValue(val) {
      this.value = this.multiple === false ? [clone(val)] : clone(val)
    }
  }
}
</script>
